export default function inputFocusEvent(actions) {
  actions.classList.remove('display--none');
}



// WEBPACK FOOTER //
// ./js/components/tables/inline-edit/events/inputFocusEvent.js